import { Component } from '@angular/core';
import { SocialAiPlatformsTableComponent } from '../../components/tables/social-ai-platforms-table/social-ai-platforms-table.component';

@Component({
  selector: 'app-social-ai-platforms',
  imports: [SocialAiPlatformsTableComponent],
  templateUrl: './social-ai-platforms.component.html',
  styleUrl: './social-ai-platforms.component.scss'
})
export class SocialAiPlatformsComponent {

}
